import { customAxios } from "../../axios/CustomAxios";
import {myIpAddress} from "../../config";

// 전체 유저 리스트
const userWorkInfo =()=>{
    return customAxios.get(myIpAddress+'/user/all');
}
export default userWorkInfo;